import React from "react";
import sign from "../../images/sign.PNG"
import sign1 from "../../images/sign2.PNG";
import locale from '../../utils/locale';

const Signature = () => (
  <div className="signature">
    <h4>{locale('ensure_to_sign_your_title')}</h4>
    <img src={sign} />
    <h4>
    {locale('Otherwise_sign_limited_power_of_attorney:')}
    </h4>
    <img src={sign1} />
  </div>
);

export default Signature;


// WEBPACK FOOTER //
// ./src/components/Signature/index.js